import { render, staticRenderFns } from "./TransferPayment.vue?vue&type=template&id=1bcfa2d4&scoped=true"
import script from "./TransferPayment.vue?vue&type=script&lang=js"
export * from "./TransferPayment.vue?vue&type=script&lang=js"
import style0 from "./TransferPayment.vue?vue&type=style&index=0&id=1bcfa2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfa2d4",
  null
  
)

export default component.exports